import { MutationHookOptions, useMutation } from '@apollo/client'
import gql from 'graphql-tag'
import {
  Mutation,
  MutationUpdateDealItemAnswersWithoutRecalculationArgs,
} from '@/schemaTypes'
import { dealCalculationFragments, dealFragments } from './dealFragments'

const UPDATE_DEAL_ITEM_ANSWERS_WITHOUT_RECALCULATION = gql`
  mutation updateDealItemAnswersWithoutRecalculation(
    $dealId: ObjectId!
    $args: UpdateDealItemAnswersArgs!
  ) {
    updateDealItemAnswersWithoutRecalculation(dealId: $dealId, args: $args) {
      _id
      items {
        ...DealItemFragment
      }
      dealValorizationCalculation {
        ...DealValorizationCalculationFragment
      }
      pawnData {
        ...PawnDataFragment
      }
      purchaseData {
        ...PurchaseDataFragment
      }
    }
  }
  ${dealFragments.pawnData}
  ${dealFragments.dealItem}
  ${dealFragments.purchaseData}
  ${dealCalculationFragments.dealValorizationCalculation}
`

type TData = {
  updateDealItemAnswersWithoutRecalculation: Mutation['updateDealItemAnswersWithoutRecalculation']
}
type TVariables = MutationUpdateDealItemAnswersWithoutRecalculationArgs

export function useUpdateDealItemAnswersWithoutRecalculation(
  opts: MutationHookOptions<TData, TVariables> = {},
) {
  return useMutation<TData, TVariables>(
    UPDATE_DEAL_ITEM_ANSWERS_WITHOUT_RECALCULATION,
    opts,
  )
}
